import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as fromActions from '../actions/settings.actions';
import { AumicoSettingsService } from '../services/aumico-settings.service';
import { getDebug, getTag } from '../utils/debugUtil';

const filename =
    '/home/user/aumico-dev-env/frontend/aumico-proto-application/projects/aumico-lib-settings-fe/src/lib/effects/accounting-basis.effects.ts';
const debug = getDebug(filename);
const TAG = getTag(filename);

@Injectable()
export class AccountingBasisEffects {
    constructor(private actions$: Actions, private service: AumicoSettingsService) {}

    getAllAccountingBasis$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.accountingBasisActions.getAllAccountingBasis),
            mergeMap((action) => {
                return this.service.getAllAccountingBasis(action.payload).pipe(
                    map((response) => {
                        return fromActions.accountingBasisActions.onGetAllAccountingBasisSuccess({
                            payload: response,
                        });
                    }),
                    catchError((error) => {
                        return of(fromActions.accountingBasisActions.onGetAllAccountingBasisFailed({ payload: error }));
                    }),
                );
            }),
        ),
    );

    submitCreateAccountingBasis$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.accountingBasisActions.submitCreateAccountingBasis),
            mergeMap((action) => {
                const observable$ = this.service.createAccountingBasis(action.payload);
                return observable$.pipe(
                    map(() => {
                        return fromActions.accountingBasisActions.onSubmitCreateAccountingBasisSuccess();
                    }),
                    catchError((error) => {
                        return of(
                            fromActions.accountingBasisActions.onSubmitCreateAccountingBasisFailed({
                                payload: error,
                            }),
                        );
                    }),
                );
            }),
        ),
    );

    submitEditAccountingBasis$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.accountingBasisActions.submitEditAccountingBasis),
            mergeMap((action) => {
                const observable$ = this.service.updateAccountingBasis(action);
                return observable$.pipe(
                    map(() => {
                        return fromActions.accountingBasisActions.onSubmitEditAccountingBasisSuccess();
                    }),
                    catchError((error) => {
                        return of(
                            fromActions.accountingBasisActions.onSubmitEditAccountingBasisFailed({
                                payload: error,
                            }),
                        );
                    }),
                );
            }),
        ),
    );
}
